import React, {useEffect, useState} from "react";
import {Playertool} from "../Util/PlayerTool/Playertool";
import {Avatar, Col, Row,Select ,Card,Menu, Modal,Upload,Dropdown,Tag,Badge,Input, Button, Typography, message, List, Drawer} from "antd";
import { Tabs } from 'antd';
import cookie from "react-cookies";
import { UploadOutlined ,VideoCameraOutlined} from '@ant-design/icons';
import Player from 'griffith'
import {getHostAddress,getFrontEndAddress,getFileAddress} from "../../Tool/UtileFun"
import {FileViewerTool} from "../Util/fileViewer/FileViewerTool";
import InfiniteScroll from 'react-infinite-scroller';
import { Scrollbars } from 'react-custom-scrollbars';
import {IsDownLoad} from "./IsDownLoad";
import FileViewer from "react-file-viewer";
import BraftEditor from "braft-editor";
import {SyncOutlined} from '@ant-design/icons';


export function VideoAndOtherFileResources(){

    useEffect(
        ()=>{
            loadExperiment()
            loadVideoList()
            //setVideoAddress(<Player sources={sources}></Player>)
            changeVideoAddress({resourcesAddress:""})
            findSourcesAddress()
        },[]
    );

    const experimentID = "experimentID"
    const role = "role"
    const { TabPane } = Tabs;
    const { Text, Link } = Typography;
    const { TextArea } = Input;
    const { Option } = Select;

    const [experiment,setExperiment] = useState({})
    const [videoList,setVideoList] = useState([])
    const [videoAddress,setVideoAddress] = useState()
    const [videoConfig,setVideoConfig] = useState()
    const [add,setAdd] = useState("")
    const [otherFile,setOtherFile] = useState([])
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [fileInfo,setFileInfo] = useState({})
    const [load,setLoad] = useState(false)
    const [editModal,setEditModal] = useState(false)
    const [confirmDeleteModal,setConfirmDeleteModal] = useState(false)
    const [deleteVideoModal,setDeleteVideoModal] = useState(false)
    const [editVideoInfo,setEditVideoInfo] = useState(false)
    const [otherFileUploadModal,setOtherFileUploadModal] = useState(false)



    const callback = (key)=> {
        console.log(key);
    }

    const showEditModal = () => {
        //todo
        setEditModal(true);
        //
        // exportExcel()
    };

    const handleDown = () =>{
        //XHRLoadLoadFile("http://localhost:8080/batchImportApi/download",{classId:"2"})
        exportExcel()
    }

    let data;
    const handleOkEditModal = () => {

        setEditModal(false);

        if ((targetValue == null || targetValue == undefined || targetValue == "") &&
            (descriptionValue == null || descriptionValue == undefined || descriptionValue == "") &&
            (contentValue == null || contentValue == undefined || contentValue == "") &&
            (stepValue == null || stepValue == undefined || stepValue == "") &&
            (teachValue == null || teachValue == undefined || teachValue == "")){
            console.log("全部为空")
            return
        }

        console.log(targetValue)
        console.log(descriptionValue)
        console.log(contentValue)
        console.log(stepValue)
        console.log(teachValue)

        data = {
            id:experiment.id,
            target:targetValue,
            description:descriptionValue,
            content:contentValue,
            step:stepValue,
            teach:teachValue
        }

        updateExperiment(data)
    };




    const handleCancelEitModal = () => {
        setEditModal(false);
    };


    const [targetValue,setTargetValue] = useState()
    const targetInputOnChange = e => {
        setTargetValue(e.target.value)
    };

    const [descriptionValue,setDescriptionValue] = useState()
    const descriptionInputOnChange = e => {
        setDescriptionValue(e.target.value)
    };


    let editDescriptionValue
    const handleEditorDescriptionChange = (editorState) => {
        editDescriptionValue = editorState.toHTML()
        console.log(editDescriptionValue)
    }

    let editContentValue
    const handleEditorContentChange = (editorState) => {
        editContentValue = editorState.toHTML()
        console.log(editContentValue)
    }

    let editStepValue
    const handleEditorStepChange = (editorState) => {
        editStepValue = editorState.toHTML()
        console.log(editStepValue)
    }

    let editTeachValue
    const handleEditorTeachChange = (editorState) => {
        editTeachValue = editorState.toHTML()
        console.log(editTeachValue)
    }


    const handleOkRichTextSave = () =>{
        let data ={
            id:experiment.id,
            target:targetValue,
            description:editDescriptionValue,
            content:editContentValue,
            step:editStepValue,
            teach:editTeachValue,
            experimentOrder:experiment.experimentOrder
        }
        updateExperiment(data)
        setEditModal(false)
    }



    const [contentValue,setContentValue] = useState()
    const contentInputOnChange = e => {
        setContentValue(e.target.value)
    };

    const [stepValue,setStepValue] = useState()
    const stepInputOnChange = e => {
        setStepValue(e.target.value)
    };

    const [teachValue,setTeachValue] = useState()
    const teachInputOnChange = e => {
        setTeachValue(e.target.value)
    };


    const loadExperiment=()=>{
        fetch(
            "http://"+getHostAddress()+"/experiment/findById",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({id:cookie.load(experimentID)}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setExperiment(data)
                console.log(data)
            })
            .catch(error => message.error("error"+error));
    }

    const exportExcel=()=>{
        let token = "Bearer " + sessionStorage.getItem('token')
        fetch(
            "http://"+getHostAddress()+"/batchImportApi/exportResults",
            {
            method:'post',
            headers: {
                'Content-type': 'application/json;charset=UTF-8',
                'Authorization': token,
            },
            body:JSON.stringify({classId:"2"}),
        }).then(res => res.blob().then(blob => {
            console.log(res === undefined)
            let filename = res.headers.get('File-Name');
            console.log(filename)
            //let filename="test.xls"
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename);  //兼容ie10
            } else {
                let a = document.createElement('a');
                document.body.appendChild(a) //兼容火狐，将a标签添加到body当中
                let url = window.URL.createObjectURL(blob);   // 获取 blob 本地文件连接 (blob 为纯二进制对象，不能够直接保存到磁盘上)
                a.href = url;
                a.download = filename;
                a.target='_blank'  // a标签增加target属性
                a.click();
                a.remove()  //移除a标签
                window.URL.revokeObjectURL(url);
            }
        }))
    }

    const loadVideoList=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/resourcesAddress/findByExperimentIdVideo",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({id:cookie.load(experimentID)}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setVideoList(data)
                console.log(data)
                // let temp
                // data.map((item, index)=>
                //     {temp[index] = item}
                // )

                //这里设置初始加载的视频地址
                if (data[0]!=null && data[0]!=undefined && data[0]!="" && data!="{}"){
                    if (ifFormat(data[0].relativeAddress)) {
                        //关闭文件查看器
                        setShowFileState()
                        setPlayerstateId(data[0].id)
                        //开启视频查看器
                        setVideoAddress(pl(data[0]))
                    }else {
                        let props = {
                            //filePath:data[0].resourcesAddress,
                            fileType:getFormat(data[0].relativeAddress),
                            relativeAddress:data[0].relativeAddress
                        }

                        //关闭视频查看器
                        setVideoAddress()

                        setPlayerstateId(data[0].id)
                        //开启文件查看器
                        setShowFileState(<Col style={{height:document.body.clientHeight - (document.body.clientHeight * 0.2),backgroundColor:"white"}}><FileViewerTool style={{position:"relative",zIndex:10}} {...props}></FileViewerTool></Col>)
                    }
                }
            })
            .catch(error => message.error("error"+error));
    }


    //根据实验id获取实验资源
    const findSourcesAddress=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/resourcesAddress/findOtherFileList",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({experimentId:cookie.load(experimentID),role:cookie.load(role)}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setOtherFile(data)
            })
            .catch(error => message.error("error"+error));
    }

    const updateExperiment=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/experiment/updateExperiment",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify(value),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                console.log(data)
                setExperiment(data)
            })
            .catch(error => message.error("error"+error));
    }


    const deleteOtherFileResources=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/resourcesAddress/deleteById",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({id:value}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                //删除后刷新
                findSourcesAddress()
            })
            .catch(error => message.error("error"+error));
    }

    const deleteVideoResources=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/resourcesAddress/deleteById",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({id:value}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                //删除后刷新
                loadVideoList()
            })
            .catch(error => message.error("error"+error));
    }

    const saveFilePath=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/resourcesAddress/videoSave",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify(value),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                //setVideoList(data)
                loadVideoList("")
            })
            .catch(error => message.error("error"+error));
    }

    const editVideo=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/resourcesAddress/edit",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify(value),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                //刷新视频
                loadVideoList("")
            })
            .catch(error => message.error("error"+error));
    }


    const saveOtherFileInfo=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/resourcesAddress/edit",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify(value),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                //刷新视频
                findSourcesAddress()
            })
            .catch(error => message.error("error"+error));
    }

    const XHRLoadLoadFile=(url, data)=>{
        let xhr = new XMLHttpRequest()
        xhr.open('post',url)
        //如果需要请求头中这是token信息可以在这设置
        xhr.setRequestHeader('Content-Type','application/json;charset=UTF-8')
        xhr.responseType = 'blob'
        xhr.send(JSON.stringify(data))
        xhr.onreadystatechange = function(){

                const blob = new Blob([xhr.response])
                let url = window.URL.createObjectURL(blob)
                console.log(url)
                //创建一个a标签元素，设置下载属性，点击下载，最后移除该元素
                let link = document.createElement('a')
                link.href = url
                link.style.display = 'none'
                //取出下载文件名
                const fileName = xhr.getResponseHeader('fileName')
                const downlaodFileName = decodeURIComponent(fileName)

                link.setAttribute('download',downlaodFileName)
                link.click()
                window.URL.revokeObjectURL(url)
        }
    }

    const [playerstateId,setPlayerstateId] = useState()
    const playerIoc = (value) =>{
        if(value.id === playerstateId){
            return <Tag icon={<SyncOutlined spin />} color="success">正在播放中</Tag>
        }
    }

    const lists = (
        <List
            itemLayout="horizontal"
            dataSource={videoList}
            pagination={{
                onChange: page => {
                    console.log(page);
                },
                pageSize: 3,
            }}
            renderItem={item => (
                <List.Item
                    actions={[<Button type="link"  onClick={()=>VideoEditModal(item)}>编辑</Button>,<Button type="text" danger onClick={()=>deleteVideo(item)}>删除</Button>]}
                >
                    <List.Item.Meta
                        avatar={
                            <Badge count={""}>
                                <VideoCameraOutlined onClick={()=>changeVideoAddress(item)} />
                            </Badge>
                        }
                        title={<a  onClick={()=>changeVideoAddress(item)}>{item.resourcesName}{playerIoc(item)}</a>}
                        //description={}
                    />
                </List.Item>
            )}
        />
    )

    const [videoResourcesId,setVideoResourcesId] = useState()
    const VideoEditModal = (value) =>{
        setVideoResourcesId(value)
        editVideoInfoModalShow()
    }
    const editVideoInfoModalShow=()=>{
        setEditVideoInfo(true)
    }

    const editVideoInfoModalOk=()=>{
        console.log("----------------------------")
        console.log(videoResourcesId)
        if (videoName == null || videoName == undefined || videoName ==""){
            setEditVideoInfo(false)
            return
        }
        videoContent = videoName;
        if (videoContent == null || videoContent == undefined || videoContent ==""){
            setEditVideoInfo(false)
            return
        }
        const videoInfo = {
            id:videoResourcesId.id,
            content:videoContent,
            resourcesName:videoName,
            experimentId:videoResourcesId.experimentId,
            knowledgeLibrary:videoResourcesId.knowledgeLibrary,
            relativeAddress:videoResourcesId.relativeAddress,
            resourceOrder:videoResourcesId.resourceOrder,
            resourcesAddress:videoResourcesId.resourcesAddress,
            role:videoResourcesId.role,
            type:videoResourcesId.type,
            userId:videoResourcesId.userId
        }
        editVideo(videoInfo)
        console.log(videoInfo)
        setEditVideoInfo(false)
    }

    const editVideoInfoModalCancel=()=>{
        setEditVideoInfo(false)
    }


    const [videoId,setVideoId] = useState()
    const deleteVideo = (value) =>{
        setVideoId(value)
        deleteVideoModalShow()
    }

    const deleteVideoModalShow=()=>{
        setDeleteVideoModal(true)
    }

    const deleteVideoModalOk=()=>{
        console.log(videoId)
        deleteVideoResources(videoId.id)
        setDeleteVideoModal(false)
    }

    const deleteVideoModalCancel=()=>{
        setDeleteVideoModal(false)
    }

    const otherFileUploadModalShow=()=>{
        setOtherFileUploadModal(true)
    }

    const otherFileUploadModalOk=()=>{

        setOtherFileUploadModal(false)
    }

    const otherFileUploadModalCancel=()=>{
        setOtherFileUploadModal(false)
    }


    const icon = (type)=>{
        if (type === 'xlsx'){
            return "http://"+getFileAddress()+"/experimentResources/icon/xlsx.jpg"
        }
        if (type === 'pptx'){
            return "http://"+getFileAddress()+"/experimentResources/icon/ppt.jpg"
        }
        if (type === 'docx'){
            return "http://"+getFileAddress()+"/experimentResources/icon/docx.jpg"
        }
        if (type === 'jpg'){
            return "http://"+getFileAddress()+"/experimentResources/icon/picture.jpg"
        }
        return "http://"+getFileAddress()+"/experimentResources/icon/otherFile.jpg"
    }

    const isDownLoad=(item)=>{
        if(experiment.isDownLoad === "teacher" || experiment.isDownLoad === "all"){
            return <a href={"http://"+getFrontEndAddress()+item.relativeAddress} download={item.resourcesName}>{item.resourcesName}</a>
        }else {
            return <p>item.resourcesName</p>
        }
    }

    //let otherFileValue = ""
    const [otherFileValue,setotherFileValue] = useState()
    const handleEditOtherFile=(value)=>{
        setotherFileValue(value)
        //otherFileValue = value
        console.log(otherFileValue)
        editOtherFileModalShow()
    }

    const [editOtherFileModal,setEditOtherFileModal] = useState(false)
    const editOtherFileModalShow=()=>{
        setEditOtherFileModal(true)
    }

    const editOtherFileModalOk=()=>{
        //如果权限没有发生改变  则直接退出
        if (otherFileValue.role === selectLookValue && otherFileValue.isDownLoad === selectOtherFileDownLoad){
            setEditOtherFileModal(false)
            return
        }else {
            let uploadFileInfo = {
                id:otherFileValue.id,
                experimentId:otherFileValue.experimentId,
                knowledgeLibrary:otherFileValue.knowledgeLibrary,
                role:selectLookValue,
                type:otherFileValue.type,
                resourcesName:otherFileValue.resourcesName,
                content:otherFileValue.content,
                relativeAddress:otherFileValue.relativeAddress,
                isDownLoad:selectOtherFileDownLoad
            }
            saveOtherFileInfo(uploadFileInfo)
            console.log(uploadFileInfo)
        }
        setEditOtherFileModal(false)
    }
    const editOtherFileModalCancel=()=>{
        setEditOtherFileModal(false)
    }

    const [selectLookValue,setSelectLookValue] = useState("all")
    let look = "all"
    const otherFileSelectHandleChange=(value)=>{
        look = value
        setSelectLookValue(look)
        console.log(look)
    }

    const [selectOtherFileDownLoad,setSelectOtherFileDownLoad] = useState("all")
    let roleDown = "all"
    const selectOtherFileDownLoadHandleChange=(value)=>{
        roleDown = value
        setSelectOtherFileDownLoad(roleDown)
        console.log(roleDown)
    }

    const otherFileList = (
        <>
        {/*旧版弹窗*/}

        {/*<List*/}
        {/*    itemLayout="horizontal"*/}
        {/*    dataSource={otherFile}*/}
        {/*    pagination={{*/}
        {/*        onChange: page => {*/}
        {/*            console.log(page);*/}
        {/*        },*/}
        {/*        pageSize: 3,*/}
        {/*    }}*/}
        {/*    renderItem={item => (*/}
        {/*        <List.Item*/}
        {/*            actions={[<a  onClick={()=>showModal({filePath:item.resourcesAddress,fileType:item.type,relativeAddress:item.relativeAddress})} key="list-loadmore-edit" target={"_blank"} download="filename">预览</a>,*/}
        {/*                <Button type="link" onClick={()=>handleEditOtherFile(item)}>编辑</Button>,*/}
        {/*                <Button type="text" danger onClick={()=>otherFileDelete(item)}>删除</Button>*/}
        {/*            ]}*/}
        {/*        >*/}
        {/*            <List.Item.Meta*/}
        {/*                avatar={<Avatar src={icon(item.type)} />}*/}
        {/*                title={<IsDownLoad {...item}></IsDownLoad>}*/}
        {/*                //description={item.content}*/}
        {/*            />*/}
        {/*        </List.Item>*/}
        {/*    )}*/}
        {/*/>*/}

            <List
                itemLayout="horizontal"
                dataSource={otherFile}
                pagination={{
                    onChange: page => {
                        console.log(page);
                    },
                    pageSize: 6,
                }}
                renderItem={item => (
                    <List.Item
                        actions={[
                            <Dropdown overlay={
                                <Menu>
                                    <Menu.Item key="2">
                                        <a  onClick={()=>changeVideoAddress(item)} key="list-loadmore-edit" target={"_blank"} download="filename">预览</a>
                                    </Menu.Item>
                                    <Menu.Item key="1">
                                        <Button type="link" onClick={()=>handleEditOtherFile(item)}>编辑</Button>
                                    </Menu.Item>
                                    <Menu.Item key="3">
                                        <Button type="text" danger onClick={()=>otherFileDelete(item)}>删除</Button>
                                    </Menu.Item>
                                </Menu>
                            }>
                                <a  onClick={e => e.preventDefault()}>
                                    操作
                                </a>
                            </Dropdown>
                        ]}
                    >
                        <List.Item.Meta
                            avatar={<Avatar src={icon(item.type)} />}
                            title={<IsDownLoad {...item}></IsDownLoad>}
                            //description={item.content}
                        />
                    </List.Item>
                )}
            />
        </>
    )

    const [otherFileId,setOtherFileId] = useState()
    const otherFileDelete = (value) =>{
        setOtherFileId(value.id)
        console.log(value.id)
        deleteOtherShowModal()
    }

    const deleteOtherFileHandleOk=()=>{
        console.log(otherFileId)
        deleteOtherFileResources(otherFileId)
        setConfirmDeleteModal(false)
    }

    const deleteOtherShowModal=()=>{
        setConfirmDeleteModal(true)
    }

    const deleteOtherFileHandleCancel=()=>{
        setConfirmDeleteModal(false)
    }

    const propsData = {
        name: 'file',
        listType: 'video',
        action: "http://"+getHostAddress()+"/resourcesAddress/videoUpload",
        headers: {
            authorization: 'authorization-text',
        },
        beforeUpload(file) {
            console.log(file.name)
            if (file.size > 1048576*500){
                message.info("上传文件最大支持500MB")
                return false
            }
            let fileName = file.name
            let format = ""
            let realFormat = ""
            for (let i = fileName.length - 1; i >= 0; i--) {
                console.log(fileName[i])
                if (fileName[i] === "."){
                    break
                }
                if (fileName[i] !== "."){
                    format = format + fileName[i]
                }
            }

            for (let i = format.length - 1 ; i >= 0 ; i--) {
                if (format[i] !=="."){
                    realFormat = realFormat + format[i]
                }
            }
            // if (realFormat!=="mp4"){
            //     message.info("仅支持mp4格式的视频")
            //     return false
            // }
            return true
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
                console.log("返回")
                console.log(info.file.response)
            }
            if (info.file.status === 'done' && info.file.response.state === 'success') {
                message.success(`${info.file.name} 文件上传成功`);
                saveFilePath({experimentId:experiment.id,videoName:info.file.name,realName:info.file.response.newFileName})
            } else if (info.file.status === 'error' && info.file.response.state === 'error') {
                message.error(`${info.file.name} 文件上传失败`);
            }
        },
    };

    const [fileFormat,setFileFormat] = useState("")
    const [fileName,setFileName] = useState("")
    const otherFileUpload = {
        name: 'file',
        listType: 'video',
        action: "http://"+getHostAddress()+"/resourcesAddress/videoUpload",
        headers: {
            authorization: 'authorization-text',
        },
        beforeUpload(file) {
            console.log(file.name)
            if (file.size > 1048576*500){
                message.info("上传文件最大支持500MB")
                return false
            }
            let fileName = file.name
            let format = ""
            let realFormat = ""
            for (let i = fileName.length - 1; i >= 0; i--) {
                console.log(fileName[i])
                if (fileName[i] === "."){
                    break
                }
                if (fileName[i] !== "."){
                    format = format + fileName[i]
                }
            }

            for (let i = format.length - 1 ; i >= 0 ; i--) {
                if (format[i] !=="."){
                    realFormat = realFormat + format[i]
                }
            }
            //记录文件名称和格式
            setFileName(file.name)
            setFileFormat(realFormat)
            return true
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
                console.log("返回")
                console.log(info.file.response)
            }
            if (info.file.status === 'done' && info.file.response.state === 'success') {
                message.success(`${info.file.name} 文件上传成功`);
                //上传成功后写入文件路径到数据库，刷新文件列表
                saveOtherFile(info.file.response.newFileName)
            } else if (info.file.status === 'error' && info.file.response.state === 'error') {
                message.error(`${info.file.name} 文件上传失败`);
            }
        },
    };


    const saveOtherFile=(value)=>{

        let uploadFileInfo = {
            experimentId:experiment.id,
            knowledgeLibrary:"otherFile",
            role:selectValue,
            type:fileFormat,
            resourcesName:fileName,
            content:selectValue,
            relativeAddress:"/experimentResources/knowledgeLibrary/"+value,
            isDownLoad:selectDownLoad
        }
        saveOtherFileInfo(uploadFileInfo)
    }


    const listProps = {
        column:3,
    }


    let vAddress
    let sources = {
        hd: {
            play_url: add.relativeAddress,
        },
        sd: {
            play_url: add.relativeAddress,
        },
    }
    const playerId = {
        id:add.id === ""||add.id===''?'0':add.id
    }


    const changeVideoAddress = (value) =>{
        //setVideoAddress(<Player sources={sources}></Player>)
        //window.opener.location.href=window.opener.location.href;
        //relativeAddress
        if (value.relativeAddress === null || value.relativeAddress === undefined){

        }else {
            //判断文件格式
            if (ifFormat(value.relativeAddress)){
                //关闭文件查看器
                setShowFileState()
                //开启视频查看器
                setPlayerstateId(value.id)
                setVideoAddress(pl(value))
                setAdd(value)
            }else {
                let temp = value.resourcesAddress
                let props = {
                    //filePath:value.resourcesAddress,
                    fileType:getFormat(value.relativeAddress),
                    relativeAddress:value.relativeAddress
                }
                //关闭视频查看器
                setVideoAddress()
                setPlayerstateId(value.id)
                //开启文件查看器
                setShowFileState(<Col style={{height:document.body.clientHeight - (document.body.clientHeight * 0.2),backgroundColor:"white"}}><FileViewerTool style={{position:"relative",zIndex:10}} {...props}></FileViewerTool></Col>)
            }
        }
        console.log(value)
    }

    const [showFileState,setShowFileState] =useState()

    const ifFormat=(fileName)=>{
        let format = ""
        let realFormat = ""
        for (let i = fileName.length - 1; i >= 0; i--) {
            console.log(fileName[i])
            if (fileName[i] === "."){
                break
            }
            if (fileName[i] !== "."){
                format = format + fileName[i]
            }
        }

        for (let i = format.length - 1 ; i >= 0 ; i--) {
            if (format[i] !=="."){
                realFormat = realFormat + format[i]
            }
        }
        if (realFormat==="mp4"){
            return true
        }else {
            return false
        }
    }

    const getFormat=(fileName)=>{
        let format = ""
        let realFormat = ""
        for (let i = fileName.length - 1; i >= 0; i--) {
            console.log(fileName[i])
            if (fileName[i] === "."){
                break
            }
            if (fileName[i] !== "."){
                format = format + fileName[i]
            }
        }

        for (let i = format.length - 1 ; i >= 0 ; i--) {
            if (format[i] !=="."){
                realFormat = realFormat + format[i]
            }
        }
        return realFormat
    }

    const showModal = (fileData) => {
        cookie.save("filePath",fileData.filePath)
        cookie.save("fileType",fileData.fileType)
        //window.open(getFrontEndAddress()+"/user/fileView")
        console.log("-------fileDatasssss-------")
        console.log(fileData)
        setLoad(true)
        setFileInfo(fileData)
        setIsModalVisible(true);
    };

    const fileViewFun=()=>{
        console.log(fileInfo)
        if (load === true)
            return  <FileViewerTool {...fileInfo}></FileViewerTool>
    }

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setFileInfo("")
    };


    let getUUID=()=>{
        let s = [];
        let hexDigits = "0123456789abcdef";
        for (let i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-";

        let uuid = s.join("");
        return uuid;
    }

    let pl = (value) =>{
        let sources = {
            hd: {
                play_url: "http://"+getFileAddress() +value.relativeAddress,
            },
            sd: {
                play_url: "http://"+getFileAddress() +value.relativeAddress,
            },
        }
        const propss = {
            id:value.id,
            //id:getUUID(),
            title:value.resourcesName,
            cover:"http://"+getFileAddress() +"/experimentResources/icon/videoCover.jpg"
        }
        return <Player sources={sources} {...propss}></Player>
    }

    const [resourcesName,setResourcesName] = useState()
    let videoName
    const resourcesNameOnChange = e =>{
        videoName = e.target.value
    }
    const [resourcesContent,setResourcesContent] = useState()
    let videoContent
    const resourcesContentOnChange = e =>{
        videoContent = e.target.value
    }

    const [selectValue,setSelectValue] = useState("all")
    const selectHandleChange=(value)=>{
        setSelectValue(value)
        console.log(selectValue)
    }

    const [selectDownLoad,setSelectDownLoad] = useState("all")
    const selectDownLoadHandleChange=(value)=>{
        setSelectDownLoad(value)
        console.log(selectDownLoad)
    }

    const showLookJurisdiction=()=>{
        let temp = otherFileValue
        if (temp === null || temp === undefined){
            return
        }
        if (temp.role === "all"){
            console.log("所有人可查看和预览")
            return "所有人可查看和预览";
        }
        if (temp.role === "teacher"){
            console.log("所有人可查看和预览")
            return "仅老师可查看和预览";
        }
    }

    const showDownLoadJurisdiction=()=>{
        let temp = otherFileValue
        if (temp === null || temp === undefined){
            return
        }
        if (temp.role === "all"){
            console.log("所有人可查看和预览")
            return "所有人可下载";
        }
        if (temp.role === "teacher"){
            console.log("所有人可查看和预览")
            return "仅老师可下载";
        }
        if (temp.role === "noDownload"){
            console.log("所有人可查看和预览")
            return "禁止所有人下载";
        }
    }


    let borSty = {
        //border:"1px solid red",
        height:document.body.clientHeight - (document.body.clientHeight * 0.2)
    }

    let scrollbarsSty = {
        height:document.body.clientHeight - (document.body.clientHeight * 0.5)
    }

    return(
        <>
            {/*<Modal title="文件上传"*/}
            {/*       visible={otherFileUploadModal}*/}
            {/*       onOk={otherFileUploadModalOk}*/}
            {/*       onCancel={otherFileUploadModalCancel}*/}
            {/*       okText={"确定"}*/}
            {/*       cancelText={"取消"}*/}
            {/*>*/}
            {/*</Modal>*/}
            <Modal title="编辑实验资料"
                   visible={editOtherFileModal}
                   onOk={editOtherFileModalOk}
                   onCancel={editOtherFileModalCancel}
                   okText={"确定"}
                   cancelText={"取消"}
            >
                <Col>
                    <Row>
                <Text>下载权限：{showLookJurisdiction()}</Text>
                    </Row>
                    <Row>
                <Text>可见权限：{showDownLoadJurisdiction()}</Text>
                    </Row>
                    <Row>
                <Select defaultValue="所有人可见" style={{ width: 120 }} onChange={otherFileSelectHandleChange}>
                    <Option value="teacher">仅老师可见</Option>
                    <Option value="all">所有人可见</Option>
                </Select>
                    </Row>
                    <Row>
                <Select defaultValue="所有人可下载" style={{ width: 120 }} onChange={selectOtherFileDownLoadHandleChange}>
                    <Option value="teacher">仅老师可下载</Option>
                    <Option value="all">所有人可下载</Option>
                    <Option value="noDownload">禁止所有人下载</Option>
                </Select>
                    </Row>
                </Col>
            </Modal>
            <Modal title="编辑视频"
                   visible={editVideoInfo}
                   onOk={editVideoInfoModalOk}
                   onCancel={editVideoInfoModalCancel}
                   okText={"确定"}
                   cancelText={"取消"}
            >
                <Input placeholder="视频名称" onChange={resourcesNameOnChange}/>
                {/*<Input placeholder="视频描述" onChange={resourcesContentOnChange}/>*/}
            </Modal>
            <Modal title="删除确认"
                   visible={deleteVideoModal}
                   onOk={deleteVideoModalOk}
                   onCancel={deleteVideoModalCancel}
                   okText={"确定"}
                   cancelText={"取消"}
            >
                <p>您确定要删除这个视频吗？</p>
            </Modal>
            <Modal title="删除确认"
                   visible={confirmDeleteModal}
                   onOk={deleteOtherFileHandleOk}
                   onCancel={deleteOtherFileHandleCancel}
                   okText={"确定"}
                   cancelText={"取消"}
            >
                <p>您确定要删除这个文件吗？</p>
            </Modal>
            <Drawer
                title=""
                width={720}
                onClose={handleCancel}
                visible={isModalVisible}
                bodyStyle={{ paddingBottom: 80 }}
            >
                {fileViewFun()}
            </Drawer>
            <Row style={borSty}>
                <Col style={borSty} span={10}>
                    <Card style={borSty} title={<Button type="primary" onClick={showEditModal}>编辑</Button>}>
                        <Tabs defaultActiveKey="1"
                              tabPosition={"left"}
                              style={borSty}
                        >
                            <TabPane tab="实验概述" key="1">
                                <p>实验名称:&nbsp;{experiment.target}</p>
                                    <Card bordered={true}>
                                        <Scrollbars
                                            style={scrollbarsSty}
                                        >
                                            <div>
                                                <div className="braft-output-content" dangerouslySetInnerHTML={{__html: experiment.description}} />
                                            </div>
                                        </Scrollbars>
                                    </Card>
                            </TabPane>
                            <TabPane tab="实验内容" key="2">
                                <Card bordered={true}>
                                    <Scrollbars style={scrollbarsSty}>
                                        <div className="braft-output-content" dangerouslySetInnerHTML={{__html: experiment.content}} />
                                    </Scrollbars>
                                </Card>
                            </TabPane>
                            <TabPane tab="实验步骤" key="3">
                                <Card bordered={true}>
                                    <Scrollbars style={scrollbarsSty}>
                                        <div className="braft-output-content" dangerouslySetInnerHTML={{__html: experiment.step}} />
                                    </Scrollbars>
                                </Card>
                            </TabPane>
                            <TabPane tab="实验资料" key="4">
                                {/*<Scrollbars*/}
                                {/*    style={scrollbarsSty}*/}
                                {/*>*/}
                                {otherFileList}
                                {/*<Select defaultValue="所有人可见" style={{ width: 120 }} onChange={selectHandleChange}>*/}
                                {/*    <Option value="teacher">仅老师可见</Option>*/}
                                {/*    <Option value="all">所有人可见</Option>*/}
                                {/*</Select>*/}
                                {/*<Select defaultValue="所有人可下载" style={{ width: 120 }} onChange={selectDownLoadHandleChange}>*/}
                                {/*    <Option value="teacher">仅老师可下载</Option>*/}
                                {/*    <Option value="all">所有人可下载</Option>*/}
                                {/*    <Option value="noDownload">禁止所有人下载</Option>*/}
                                {/*</Select>*/}
                                <Upload {...otherFileUpload}>
                                    <Button icon={<UploadOutlined />}>上传文件</Button>
                                </Upload>
                                {/*</Scrollbars>*/}
                            </TabPane>
                            <TabPane tab="实验讲解" key="5">
                                <Card bordered={true}>
                                    <Scrollbars style={{  height:document.body.clientHeight - (document.body.clientHeight * 0.7) }}>
                                        <div className="braft-output-content" dangerouslySetInnerHTML={{__html: experiment.teach}} />
                                    </Scrollbars>
                                </Card>
                                {lists}
                                <Upload {...propsData}>
                                    <Button icon={<UploadOutlined />}>上传视频</Button>
                                </Upload>
                            </TabPane>
                        </Tabs>
                    </Card>
                </Col>
                {/*实验视频组件*/}
                <Col  style={borSty} span={14}>
                    {videoAddress}
                    {showFileState}
                </Col>
            </Row>
            <Drawer
                title="编辑实验数据"
                placement="right"
                closable={false}
                onClose={handleCancelEitModal}
                visible={editModal}
                width={600}
            >
                {/*<Text>实验名称</Text>*/}
                {/*<Input placeholder={experiment.target} onChange={targetInputOnChange}/>*/}
                {/*<Text>实验概述</Text>*/}
                {/*<TextArea rows={4} placeholder={experiment.description} onChange={descriptionInputOnChange}></TextArea>*/}
                {/*<Text>实验内容</Text>*/}
                {/*<TextArea rows={4} placeholder={experiment.content} onChange={contentInputOnChange}></TextArea>*/}
                {/*<Text>实验步骤</Text>*/}
                {/*<TextArea rows={4} placeholder={experiment.step} onChange={stepInputOnChange}></TextArea>*/}
                {/*<Text>实验讲解</Text>*/}
                {/*<TextArea rows={4} placeholder={experiment.teach} onChange={teachInputOnChange}></TextArea>*/}

                <Button type="primary" onClick={handleOkRichTextSave}>保存</Button>
                <Button  onClick={handleCancelEitModal}>取消</Button>
                <Tabs defaultActiveKey="1">
                    <TabPane tab="实验名称" key="1">
                        <Text>实验名称</Text>
                        <Input placeholder={experiment.target} onChange={targetInputOnChange}/>
                    </TabPane>
                    <TabPane tab="实验概述" key="2">
                        <div className="braft-output-content">
                            <BraftEditor
                                value={BraftEditor.createEditorState(experiment.description)}
                                onChange={handleEditorDescriptionChange}
                                //onSave={submitContent}
                            />
                        </div>
                    </TabPane>
                    <TabPane tab="实验内容" key="3">
                        <div className="braft-output-content">
                            <BraftEditor
                                value={BraftEditor.createEditorState(experiment.content)}
                                onChange={handleEditorContentChange}
                                //onSave={submitContent}
                            />
                        </div>
                    </TabPane>
                    <TabPane tab="实验步骤" key="4">
                        <div className="braft-output-content">
                            <BraftEditor
                                value={BraftEditor.createEditorState(experiment.step)}
                                onChange={handleEditorStepChange}
                                //onSave={submitContent}
                            />
                        </div>
                    </TabPane>
                    <TabPane tab="讲解" key="5">
                        <div className="braft-output-content">
                            <BraftEditor
                                value={BraftEditor.createEditorState(experiment.teach)}
                                onChange={handleEditorTeachChange}
                                //onSave={submitContent}
                            />
                        </div>
                    </TabPane>
                </Tabs>
                <Col span={15}>
                </Col>
            </Drawer>
            </>
    )
}
